import { useTranslation } from 'react-i18n-lite'

import { formatFileSize } from 'modules/shared/utils/formatFileSize'
import Player from 'modules/shared/WebcamStreamCapture/components/Player'
import ActivityValue from './ActivityValue'
import { StatusClass } from 'types/shared'
import { useDocumentURL } from 'modules/document/hooks'

interface ActivityDocumentVideoProps {
  values: string
  statusClass?: StatusClass
  hideDescription?: boolean
}

const ActivityDocumentVideo = ({
  values,
  statusClass,
  hideDescription
}: ActivityDocumentVideoProps) => {
  const { t } = useTranslation()

  const obj = values ? JSON.parse(values) : {}

  const { documentURL } = useDocumentURL({ s3PrivateURL: obj?.url })

  return (
    <>
      {!hideDescription && (
        <ActivityValue
          label={t('activity-document-video.labels.des')}
          value={obj.des}
          statusClass={statusClass}
        />
      )}
      <ActivityValue
        label={t('activity-document-video.labels.uuid-video')}
        value={obj.uuid}
        statusClass={statusClass}
      />
      <ActivityValue
        label={t('activity-document-video.labels.status')}
        value={obj.statusDes}
        statusClass={statusClass}
      />
      <div className='row'>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-video.labels.content-type')}
            value={obj.contentType}
            statusClass={statusClass}
          />
        </div>
        <div className='col-6'>
          <ActivityValue
            label={t('activity-document-video.labels.size')}
            value={obj.size ? formatFileSize(Number(obj.size)) : ''}
            statusClass={statusClass}
          />
        </div>
      </div>
      <div className='w-100 mb-4 d-flex justify-content-center align-items-center'>
        {documentURL ? (
          <Player source={documentURL} type={obj.contentType || 'video/mp4'} />
        ) : (
          <div className='w-100 webcam-no-image rounded'>
            {t('activity-document-video.no-video')}
          </div>
        )}
      </div>
    </>
  )
}

export default ActivityDocumentVideo
